var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1167 5.18971C7.7498 3.7746 9.83909 2.99699 12 3.00001C16.9707 3.00001 21 7.02931 21 12C21 13.9224 20.397 15.7044 19.371 17.166L16.5 12H19.2C19.2001 10.5885 18.7853 9.20803 18.0072 8.03034C17.2291 6.85265 16.1219 5.92965 14.8235 5.37612C13.525 4.82259 12.0924 4.66294 10.704 4.91702C9.31548 5.17111 8.03231 5.82772 7.014 6.80521L6.1167 5.18971ZM17.8833 18.8103C16.2502 20.2254 14.1609 21.003 12 21C7.0293 21 3 16.9707 3 12C3 10.0776 3.603 8.29561 4.629 6.83401L7.5 12H4.8C4.79988 13.4115 5.21468 14.792 5.9928 15.9697C6.77093 17.1474 7.87806 18.0704 9.17654 18.6239C10.475 19.1774 11.9076 19.3371 13.296 19.083C14.6845 18.8289 15.9677 18.1723 16.986 17.1948L17.8833 18.8103Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.c2d9d76f142aee3cda1cad37294b108b.svg";
export { ForwardRef as ReactComponent };